export const LEGEND_SWATCH_WIDTH = 25;
